// Copyright (c) 2020 Deere & Company

export const buildPayload = (accounts, getForTcsm) => ({
    accounts: accounts.map(dealer => dealer.account),
    getForTcsm
});



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/services/build-payload.js